import { render, staticRenderFns } from "./TabChats.vue?vue&type=template&id=4ca80df1&"
import script from "./TabChats.vue?vue&type=script&lang=js&"
export * from "./TabChats.vue?vue&type=script&lang=js&"
import style0 from "./TabChats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports